import React from 'react';
import Table from '../Table';
import propTypes from 'prop-types';
import { Row, Col, Button} from 'reactstrap';
import UpdateForm from './UpdateForm';

export default class ModificationTableWidget extends React.Component {
  constructor(props) {
    super(props);
    this.onPreviewButtonClick = this.onPreviewButtonClick.bind(this);
    this.onGridRowsUpdated = this.onGridRowsUpdated.bind(this);
    this.state = {
      previewed: false
    };
  }

  onPreviewButtonClick(formData) {
    const { setUiState } = this.props;

    let selectedObjects = this.props.data;

    let newRate = selectedObjects.map((rate => {
      var newRate = Object.assign({}, rate);
      let number = parseInt(formData.number);
      switch (formData.operator.value) {
        case 'PERCENT':
          newRate.newRate = newRate.rate * (1 + (number / 100));
          break;
        case 'DOLLAR':
          newRate.newRate = newRate.rate + number;
          break;
        case 'BULK_SET':
          newRate.newRate = number;
          break;
        default:
          newRate.newRate = newRate.newRate;
          break;
      }
      return newRate;
    }));

    setUiState({
      selectedObjects: newRate,
      currentUpdate: {
        operator : formData.operator.value,
        number: parseInt(formData.number)
      }
    });
    this.setState({
      previewed: true
    });

  }

  onGridRowsUpdated(rows) {
    const { setUiState } = this.props;
    setUiState({
      selectedObjects: rows,
      currentUpdate: {
        operator: "MULTI_SET"
      }
    });
    this.setState({
      previewed: true
    });
  }

  reject() {
    const { setUiState } = this.props;
    setUiState({
      selectedObjects: this.props.data
    });
  }

  render() {
    let { columns, data, bulk, onReject, onAccept } = this.props;

    // accept button calls on complete and on accept changes
    let accept = <Button onClick={() => {
      onAccept();
    }} type="submit" className="btn btn-success disable">Accept</Button>;

    return (
      <Row>
        <Col sm="12">
          {bulk ?
            <UpdateForm
              onSubmit={this.onPreviewButtonClick} />
            : null}
        </Col>

        <Col sm="12">
          <Table
            entity={null}
            data={data || []}
            columns={columns}
            onGridRowsUpdated={this.onGridRowsUpdated}
          />
        </Col>
        <Col sm="12">
          <button onClick={onReject} className="btn btn-danger">Reject</button>
          &nbsp;
         {this.state.previewed ? accept : null}
        </Col>
      </Row>

    );
  }
}

ModificationTableWidget.propTypes = {
  columns: propTypes.array.isRequired,          // columns to display in the table
  data: propTypes.array.isRequired,             // data to diplay in the table
  bulk: propTypes.bool.isRequired,              // display this widet in bulk edit mode 
  //onComplete: propTypes.func.isRequired,        //
  onReject: propTypes.func.isRequired,          // when the reject button is clikce
  //onAcceptChanges: propTypes.func.isRequired,   // when the accept button is clicked
  setUiState: propTypes.func.isRequired         // set the ui state for this widget
};



// WEBPACK FOOTER //
// ./src/components/RateManagment/ModificationTableWidget.js